import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateProfile } from '../../store/actions/projectActions'
import { Redirect } from 'react-router-dom'
import firebase from "firebase";
import M from 'materialize-css';
import { withRouter } from "react-router";

M.AutoInit();

class UserProfile extends Component {
  state = {
    privateAddress: this.props.profile.privateAddress,
    companyName: this.props.profile.companyName,
    companyTitle: this.props.profile.companyTitle,
    companyAddress: this.props.profile.companyAddress
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   if (nextProps.profile.esign && prevState.registered) {
  //     M.toast({ html: 'E-sign registered', classes: 'rounded', displayLength: 8000 })
  //     nextProps.history.push('/')
  //   }
  //   return null;
  // }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  onSave = e => {
    let promise = Promise.resolve();
    promise
      .then(this.props.updateProfile(this.state))
      .then(M.toast({ html: 'Your profile is updated!', classes: 'rounded', displayLength: 8000 }))
  }

  onReset = currentProfile => e => {
    this.setState({
      privateAddress: currentProfile.privateAddress,
      companyName: currentProfile.companyName,
      companyTitle: currentProfile.companyTitle,
      companyAddress: currentProfile.companyAddress
    })
  }
  render() {

    const { auth, profile } = this.props
    const currentProfile = {
      privateAddress: profile.privateAddress,
      companyName: profile.companyName,
      companyTitle: profile.companyTitle,
      companyAddress: profile.companyAddress
    }
    const fullname = profile.firstName + " " + profile.lastName
    let plan;
    if (!profile.plan) {
      plan = "Free"
    } else if (profile.plan === "1") {
      plan = "Pro"

    } else if (profile.plan === "2") {
      plan = "Premium"
    }


    if (!auth.uid) return <Redirect to={'/signin'} />

    return (
      <div className="grey lighten-5">
        <div className="container">
          <div className="row"></div>
          <h3>User Profile</h3>
          <div class="row">

            <span class="card-title"></span>
            <div className="input-field">
              <label htmlFor="name1" class="active">Your Name</label>
              <input value={fullname} type="text" id="name1" disabled />
            </div>

            <div className="input-field">
              <label htmlFor="email" class="active">Your email</label>
              <input placeholder={auth.email} value={auth.email} type="email" id="email1" disabled />
            </div>

            <div className="input-field">
              <label htmlFor="plan" class="active">Your plan</label>
              <input placeholder={plan} value={plan} type="text" id="plan" disabled />
            </div>

            <div className="input-field">
              <label className="active" htmlFor="privateAddress">Your address</label>
              <input placeholder={this.state.privateAddress} value={this.state.privateAddress} type="text" id="privateAddress" onChange={this.handleChange} />
            </div>

            <div className="input-field">
              <label className="active" htmlFor="companyName">Company Name</label>
              <input value={this.state.companyName} type="text" id="companyName" onChange={this.handleChange} />
            </div>

            <div className="input-field">
              <label className="active" htmlFor="companyTitle">Title at your company</label>
              <input value={this.state.companyTitle} type="text" id="companyTitle" onChange={this.handleChange} />
            </div>

            <div className="input-field">
              <label className="active" htmlFor="companyAddress">Your company address</label>
              <input value={this.state.companyAddress} type="text" id="companyAddress" onChange={this.handleChange} />
            </div>

            <div>TODO: login password</div>

          </div>
          <div class="row">
            <div class="col s2 m2">
              <button className="btn teal lighten-1 z-depth-1" onClick={this.onSave}>Save</button>
            </div>
            <div class="col s4 m4">
              <button className="btn white grey-text lighten-4 z-depth-1" onClick={this.onReset(currentProfile)}>Reset</button>
            </div>
          </div>
        </div>



        <div className="row"></div>
        <div className="row"></div>
        <div className="row"></div>
        <div className="row"></div>
        <div className="row"></div>
        <div className="row"></div>
      </div >
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateProfile: (newProfile) => dispatch(updateProfile(newProfile))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserProfile));